// The client side of /api/facts (BUILD-BRIEF §4, owner: people agent).
//
// There is no `updateFact`, and that absence is the contract: a value is written again, not
// edited. `createFact` on a key that already has a current value retires the old row and links
// the two, so the history of what we believed survives every correction (DESIGN §5).
import { request, qs } from './client.js';
import type { EvidenceKind, Fact, FactStatus, ListResponse, SubjectKind } from '../../shared/types.js';

export interface FactInput {
  subject_kind: SubjectKind;
  subject_id: number;
  /** A dotted catalogue slot: `identity.email`, `research.verification`. */
  key: string;
  value?: string | null;
  as_of?: string | null;
  evidence_kind?: EvidenceKind | null;
  evidence_ref?: string | null;
  quote?: string | null;
  confidence?: number | null;
}

export const listFacts = (params: { subject_kind: SubjectKind; subject_id: number; status?: FactStatus; key?: string }) =>
  request<ListResponse<Fact>>(`/facts${qs(params)}`);

/** Writes the new current value and retires whatever the key said before. */
export const createFact = (body: FactInput) =>
  request<Fact>('/facts', { method: 'POST', body: JSON.stringify(body) });

/** ◇ → ▪. Flips `confirmed_at`; the value is untouched. Idempotent. */
export const confirmFact = (id: number) =>
  request<Fact>(`/facts/${id}/confirm`, { method: 'POST' });

/** Leaves the key with no current value — an honest "we know we do not know". */
export const retractFact = (id: number, reason?: string) =>
  request<Fact>(`/facts/${id}/retract`, { method: 'POST', body: JSON.stringify({ reason: reason ?? null }) });
